module.exports = __webpack_public_path__ + "img/w40.8af5f491.svg";